import React, { useEffect, useState } from "react";
import "./ViewStore.css";
import { NavLink } from "react-router-dom";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { eye } from "react-icons-kit/feather/eye";
import { arrowUpRight } from "react-icons-kit/feather/arrowUpRight";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import { GetwidgetId, api_url } from "../apiconfig/authService";
import { RiLoaderFill } from "react-icons/ri";

function ViewWedget() {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const [mediaData, setMediaData] = useState([]);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const formatUTCDate = (utcDateString) => {
    const date = new Date(utcDateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // convert 0 → 12, 13 → 1, etc.
    hours = String(hours).padStart(2, "0");

    return `${day}-${month}-${year} at ${hours}:${minutes}:${seconds} ${ampm}`;
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response = await GetwidgetId(
          id,
          localStorage.getItem("accessToken")
        );
        setLoading(false);
        setMediaData(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-center pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Widget Title Details</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/wedget" className="btn btn-primary addSeller">
              <Icon className="eye" icon={eye} size={18} /> View All
            </NavLink>
            <NavLink
              to={`/editwedget/${id}`}
              className="btn btn-primary addSeller"
            >
              <Icon className="arrowUpRight" icon={arrowUpRight} size={18} />{" "}
              Edit
            </NavLink>
          </div>
        </div>

        {loading ? (
          <div className="d-flex align-items-center justify-content-center">
            <RiLoaderFill
              size={40}
              className="text-success spin-animation text-center"
            />
          </div>
        ) : (
          <div className="detailsBox">
            <div className="row">
              <div className="col-lg-12">
                <div className="table-responsive">
                  <table className="table table-bordered table-hover w-100">
                    <tbody>
                      <tr>
                        <th>Title</th>
                        <td>{mediaData?.title}</td>
                      </tr>
                      <tr>
                        <th>Status</th>
                        <td>{mediaData?.statusid}</td>
                      </tr>
                      <tr>
                        <th>Type</th>
                        <td>{mediaData?.type === "product" ? 'Product' : 'Category'}</td>
                      </tr>
                      <tr>
                        <th>Created By</th>
                        <td>{mediaData?.createdby}</td>
                      </tr>
                      <tr>
                        <th>Modified By</th>
                        <td>{mediaData?.createdby}</td>
                      </tr>
                      <tr>
                        <th>Created Date</th>
                        <td>{formatUTCDate(mediaData?.createddate)}</td>
                      </tr>
                      <tr>
                        <th>Modified Date</th>
                        <td>{formatUTCDate(mediaData?.modifieddate)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Product Data Section */}
            {mediaData?.products?.length > 0 && (
              <div className="row mt-4">
                <div className="col-lg-12">
                  <h5 className="fw-bold">Product Details</h5>
                  <table className="table table-bordered table-hover w-100 mt-3">
                    <tbody>
                      {mediaData?.products?.map((product, index) => (
                        <tr key={index}>
                          <td>{product.name}</td>
                          <td>
                            <img
                              width="50px"
                              height="50px"
                              src={product.imageurl} // Adjust the URL if needed
                              alt={product.name}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {mediaData?.category?.length > 0 && (
              <div className="row mt-4">
                <div className="col-lg-12">
                  <h5 className="fw-bold">Category Details</h5>
                  <table className="table table-bordered table-hover w-100 mt-3">
                    <tbody>
                      {mediaData?.category?.map((product, index) => (
                        <tr key={index}>
                          <td>{product.name}</td>
                          <td>
                            <img
                              width="50px"
                              height="50px"
                              src={`${api_url}/product/category/getCategoryImage/${product.image}`} // Adjust the URL if needed
                              alt={product.name}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ViewWedget;
